var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-list',{attrs:{"list":_vm.list,"columns":_vm.templateListColumns || _vm.columns,"group-actions":_vm.groupActions,"single-actions":_vm.singleActions,"showSearchbox":_vm.showSearchbox,"export-data-options":_vm.exportDataOptions,"show-group-actions":_vm.showGroupActions,"show-single-actions":!_vm.isTemplate,"show-page":!_vm.isTemplate}})
}
var staticRenderFns = []

export { render, staticRenderFns }